import React from 'react';
import { Modal } from '../components/policy-modal';
import { useDisableBodyScroll } from '../hooks/use-disable-body-scroll';
import { useMessages } from '../i18n/useMessages';

interface BookingTimeoutDialogProps {
  isOpen: boolean;
  onClose: VoidFunction;
}
export const BookingTimeoutDialog: React.FC<BookingTimeoutDialogProps> = ({
  isOpen,
  onClose,
}) => {
  useDisableBodyScroll(isOpen);

  const getMessage = useMessages();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      shouldCloseOnEscKey={false}
      shouldCloseOnOutsideClick={false}
    >
      <div
        id="inquiry-success-modal"
        className="bg-white px-12 py-8 rounded-xl max-w-[90vw] md:w-[640px] text-center"
      >
        <h2 className="text-center text-xl font-serif text-red-200 mt-8 font-medium">
          {getMessage('camp67-reservation.timeout.title')}
        </h2>
        <p className="mt-2">{getMessage('camp67-reservation.timeout.description')}</p>
        <div className="flex flex-row items-center gap-4 w-full justify-center mt-6">
          <button
            onClick={onClose}
            className="px-6 py-3 text-white text-xs tracking-widest uppercase font-sans font-semibold bg-red-200 -skew-x-12 rounded-md"
          >
            <p className="skew-x-12">{getMessage('camp67-reservation.timeout.ok')}</p>
          </button>
        </div>
      </div>
    </Modal>
  );
};
